/**
 * App-Lifecycle: verfolgt, ob das Portal-Fenster sichtbar ist.
 *
 * Der Dienst war ueber lange Zeit vor allem ein Anhaengsel der Wartezeitberechnung:
 * Er schrieb `appStatus/webApp` mit einem 30-Sekunden-Heartbeat und dem Feld
 * `calculatingWaitTimes`. Genau dieses Feld brachte die Cloud Function dazu,
 * ihre eigene Berechnung zu ueberspringen — das Portal wurde damit zum
 * Primaerrechner, und ein Unternehmer-Portal konnte globale Wartezeiten aus
 * seinem gefilterten Datenbestand schreiben.
 *
 * Seit dem Rueckbau rechnet ausschliesslich die Cloud Function. Damit sind
 * `appStatus/webApp`, der Heartbeat, der Cloud-Function-Statuslistener und die
 * `initializeWaitTimeCalculation`-Koordination ersatzlos entfallen — das Dokument
 * wird von niemandem mehr gelesen.
 *
 * Konzept: docs/KONZEPT_WARTEZEIT_RUECKBAU_INS_BACKEND.md
 */

class AppLifecycleManager {
  constructor() {
    this.isInitialized = false;
    this.visibilityChangeHandler = null;
    this.isAppVisible = true;

    this.initializeHandlers = this.initializeHandlers.bind(this);
    this.cleanup = this.cleanup.bind(this);
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
  }

  // App-Lifecycle-Handlers initialisieren
  initializeHandlers() {
    if (this.isInitialized) {
      console.warn('AppLifecycleManager: Already initialized');
      return;
    }

    this.visibilityChangeHandler = () => {
      this.handleVisibilityChange();
    };
    document.addEventListener('visibilitychange', this.visibilityChangeHandler);

    this.isInitialized = true;
    console.log('AppLifecycleManager: Handlers initialisiert');
  }

  // Tab-Visibility-Change Handler
  handleVisibilityChange() {
    const isVisible = !document.hidden;
    if (isVisible === this.isAppVisible) return;

    this.isAppVisible = isVisible;
    console.log(
      isVisible
        ? 'AppLifecycleManager: Tab wieder sichtbar'
        : 'AppLifecycleManager: Tab versteckt (App bleibt aktiv)'
    );
  }

  // Cleanup aller Handler
  cleanup() {
    try {
      console.log('AppLifecycleManager: Führe vollständigen Cleanup durch...');

      if (this.visibilityChangeHandler) {
        document.removeEventListener('visibilitychange', this.visibilityChangeHandler);
        this.visibilityChangeHandler = null;
      }

      this.isInitialized = false;
      console.log('AppLifecycleManager: Cleanup abgeschlossen');

    } catch (error) {
      console.error('AppLifecycleManager: Fehler beim Cleanup:', error);
    }
  }

  // Status-Informationen abrufen
  getStatus() {
    return {
      isInitialized: this.isInitialized,
      isAppVisible: this.isAppVisible,
      hasEventListeners: Boolean(this.visibilityChangeHandler)
    };
  }
}

const appLifecycleManager = new AppLifecycleManager();

export default appLifecycleManager;
